import React, { useState, useEffect, useRef } from 'react';
import { doc, getDoc, setDoc, collection, getDocs, addDoc, deleteDoc, updateDoc, writeBatch, query, where } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, functions } from '../../pages/app/protected/firebase';
import { httpsCallable } from 'firebase/functions';
import { useAuth } from '../../contexts/AuthContext';
import { quotas } from '../../pages/app/protected/services/QuotasConfig';
import { baseNavItems, baseFinanceItems, baseDisplayItems, baseToolsItems } from '../Sidebar';
import QRCode from 'react-qr-code';  

export default function CompanySettings() {
  const { user, companyId } = useAuth();
  const [activeTab, setActiveTab] = useState('general');
  const [onlineOrderingLink, setOnlineOrderingLink] = useState('');
  const [isLinkCopied, setIsLinkCopied] = useState(false);
  const [showQRModal, setShowQRModal] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
  const [products, setProducts] = useState([]);
  const [bundles, setBundles] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState({});
  const [expandedTypes, setExpandedTypes] = useState({});
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [unsavedChangesType, setUnsavedChangesType] = useState(''); // 'settings' or 'schedule'
  const [searchQuery, setSearchQuery] = useState('');
  const qrRef = useRef();
    const storage = getStorage();
const [uploadingPoster, setUploadingPoster] = useState(false);
const [uploadingQr, setUploadingQr] = useState(false);


  // Set the online ordering link when component mounts or companyId changes
  useEffect(() => {
    if (companyId) {
      const link = `${window.location.origin}/online-ordering/${companyId}`;
      setOnlineOrderingLink(link);
    } else {
      console.warn('No companyId available for generating online ordering link');
    }
  }, [companyId]);
  const [formData, setFormData] = useState({
    receiptFooter: '',
    thankYouNote: '',
    currencySymbol: 'RM',
    decimalPlaces: 2,
    taxEnabled: false,
    sst6Enabled: false,
    sst8Enabled: false,
    serviceTax10Enabled: false,
    serviceTax10Rate: 0,
    stallType: 'fnb',
    onlineOrderingEnabled: false,
    payAtCounterEnabled: true,
    stripePaymentEnabled: false,
    stripeKeyConfigured: false,
    stripeSecretKeyHint: '',
    stripeKeyMode: '',
    customerDisplayEnabled: false,
    onlineOrderingSchedule: {
      mon: { enabled: true, open: '09:00', close: '18:00' },
      tue: { enabled: true, open: '09:00', close: '18:00' },
      wed: { enabled: true, open: '09:00', close: '18:00' },
      thu: { enabled: true, open: '09:00', close: '18:00' },
      fri: { enabled: true, open: '09:00', close: '18:00' },
      sat: { enabled: true, open: '09:00', close: '18:00' },
      sun: { enabled: true, open: '09:00', close: '18:00' },
    },
    requireCustomerInfo: false,
    enablePreOrders: false,
    enablePickup: true,
    enableDelivery: false,
  });
  const [companyInfo, setCompanyInfo] = useState({});
  const [showPreview, setShowPreview] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [onlineOrderingSaving, setOnlineOrderingSaving] = useState(false);
  const [onlineOrderingMessage, setOnlineOrderingMessage] = useState('');
  const [paymentMethodError, setPaymentMethodError] = useState('');
  const [stripeKeySaving, setStripeKeySaving] = useState(false);
  const [stripeKeyMessage, setStripeKeyMessage] = useState('');
  const [stripeSecretInput, setStripeSecretInput] = useState('');
  const [generalSaving, setGeneralSaving] = useState(false);
  const [generalMessage, setGeneralMessage] = useState('');
  const [customerDisplaySaving, setCustomerDisplaySaving] = useState(false);
  const [customerDisplayMessage, setCustomerDisplayMessage] = useState('');
  const [productTypes, setProductTypes] = useState([]);
  const [newProductType, setNewProductType] = useState('');
  const [discounts, setDiscounts] = useState([]);
  const [newDiscountName, setNewDiscountName] = useState('');
  const [newDiscountValue, setNewDiscountValue] = useState('');
  const [newDiscountCode, setNewDiscountCode] = useState('');
  const [newVoucherCount, setNewVoucherCount] = useState('');
  const [newValidityStart, setNewValidityStart] = useState('');
  const [newValidityEnd, setNewValidityEnd] = useState('');
  const [shouldGenerateCode, setShouldGenerateCode] = useState(true);
  const [editingDiscount, setEditingDiscount] = useState(null);
  const [editDiscountName, setEditDiscountName] = useState('');
  const [editDiscountValue, setEditDiscountValue] = useState('');
  const [editValidityStart, setEditValidityStart] = useState('');
  const [editValidityEnd, setEditValidityEnd] = useState('');
  const [editVoucherCount, setEditVoucherCount] = useState('');
  const [cashiers, setCashiers] = useState([]);
  const [newCashierId, setNewCashierId] = useState('');
  const [newCashierName, setNewCashierName] = useState('');
  const [limitations, setLimitations] = useState({});
  const [editingProductTypeId, setEditingProductTypeId] = useState(null);
  const [editingProductTypeName, setEditingProductTypeName] = useState('');
  const [loadingPage, setLoadingPage] = useState(false);
  const [saveMessage, setSaveMessage] = useState('');
  const onlineOrderingDays = [
    { key: 'mon', label: 'Monday' },
    { key: 'tue', label: 'Tuesday' },
    { key: 'wed', label: 'Wednesday' },
    { key: 'thu', label: 'Thursday' },
    { key: 'fri', label: 'Friday' },
    { key: 'sat', label: 'Saturday' },
    { key: 'sun', label: 'Sunday' },
  ];

  const updateOnlineSchedule = (dayKey, field, value) => {
    setFormData(prev => ({
      ...prev,
      onlineOrderingSchedule: {
        ...prev.onlineOrderingSchedule,
        [dayKey]: {
          ...(prev.onlineOrderingSchedule?.[dayKey] || {}),
          [field]: value,
        },
      },
    }));
    setHasUnsavedChanges(true);
    setUnsavedChangesType('schedule');
  };

  const toggleOnlinePaymentMethod = (key) => {
    setFormData(prev => {
      const nextValue = !prev[key];
      if (key === 'stripePaymentEnabled' && nextValue && !prev.stripeKeyConfigured) {
        setPaymentMethodError('Add a Stripe secret key before enabling online payments.');
        return prev;
      }
      if (key === 'stripePaymentEnabled' && nextValue) {
        const confirmed = window.confirm(
          'Stripe payout fees will be deducted during payouts. Do you want to continue?'
        );
        if (!confirmed) {
          return prev;
        }
      }
      const next = { ...prev, [key]: nextValue };
      const hasCounter = key === 'payAtCounterEnabled' ? nextValue : Boolean(prev.payAtCounterEnabled);
      const hasStripe = key === 'stripePaymentEnabled' ? nextValue : Boolean(prev.stripePaymentEnabled);
      if (!hasCounter && !hasStripe) {
        setPaymentMethodError('At least one payment method must be enabled.');
        return prev;
      }
      setPaymentMethodError('');
      return next;
    });
    setHasUnsavedChanges(true);
    setUnsavedChangesType('settings');
  };

  const handleSaveStripeKey = async () => {
    if (!companyId) return;
    if (!stripeSecretInput.trim()) {
      setError('Stripe secret key is required.');
      return;
    }
    setStripeKeySaving(true);
    setError('');
    setStripeKeyMessage('');
    try {
      const saveKey = httpsCallable(functions, 'setTenantStripeSecretKey');
      const { data } = await saveKey({ companyId, secretKey: stripeSecretInput.trim() });
      setFormData(prev => ({
        ...prev,
        stripeKeyConfigured: true,
        stripeSecretKeyHint: data?.hint || prev.stripeSecretKeyHint,
        stripeKeyMode: data?.mode || prev.stripeKeyMode,
      }));
      setStripeSecretInput('');
      setStripeKeyMessage('Stripe key saved.');
    } catch (err) {
      console.error('Stripe key save failed:', err);
      setError('Failed to save Stripe key. Please try again.');
    } finally {
      setStripeKeySaving(false);
    }
  };

  // Sidebar settings
  const [sidebarSettings, setSidebarSettings] = useState({
    navItems: { 'Home': true, 'Cashier': true }, 
    financeItems: { 'History': true, 'Reports': true, 'Accounting': true },
    displayItems: { 'Kitchen': true, 'Queue': true, 'Pickup Status': true },
    toolsItems: { 'Help':true, 'Settings':true,'Inventory': true },
    alwaysVisible: { 'Home': true, 'Settings': true, 'Help': true } // Add always visible items here
  });

  const formatDate = (date) => {
    const d = new Date(date);
    return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1)
      .toString()
      .padStart(2, '0')}/${d.getFullYear()}`;
  };

  const formatTime = (date) => {
    const d = new Date(date);
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  useEffect(() => {
    if (!user) return;
    const fetchSettings = async () => {
      setLoadingPage(true);
      try {
        // Get company ID first
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (!userDoc.exists()) {
          throw new Error('No company associated with this user');
        }
        const userCompanyId = userDoc.data().companyId;
        if (userCompanyId !== companyId) {
          console.warn('Mismatch between auth companyId and user document companyId');
        }

        // Fetch company profile to get plan
        const companyPlanRef = doc(db, 'companies', companyId);
        const companyPlanSnap = await getDoc(companyPlanRef);
        const companyPlan = companyPlanSnap.exists() ? companyPlanSnap.data().subscription?.plan || 'Free Trial' : 'Free Trial';
        
        const quota = quotas[companyPlan] || quotas['Free'];
        setLimitations(quota);
        
        // Fetch sidebar settings
        const sidebarSettingsRef = doc(db, 'companies', companyId, 'companySettings', 'sidebar');
        const sidebarSnap = await getDoc(sidebarSettingsRef);
        if (sidebarSnap.exists()) {
          const data = sidebarSnap.data();
          const filteredNavItems = Object.entries(data.navItems || {}).reduce((acc, [key, value]) => {
            if (key !== 'Table') acc[key] = value;
            return acc;
          }, {});
          const filteredToolsItems = Object.entries(data.toolsItems || {}).reduce((acc, [key, value]) => {
            if (key !== 'Delivery') acc[key] = value;
            return acc;
          }, {});
          const mergedDisplayItems = baseDisplayItems.reduce((acc, item) => {
            acc[item.name] = data.displayItems?.[item.name] ?? !item.alwaysVisible;
            return acc;
          }, {});
          setSidebarSettings(prev => ({
            ...prev,
            ...data,
            navItems: filteredNavItems,
            toolsItems: filteredToolsItems,
            displayItems: mergedDisplayItems
          }));
        } else {
          const defaultSettings = {
            navItems: baseNavItems.reduce((acc, item) => ({
              ...acc,
              [item.name]: !item.alwaysVisible
            }), {}),
            financeItems: baseFinanceItems.reduce((acc, item) => ({
              ...acc,
              [item.name]: !item.alwaysVisible
            }), {}),
            displayItems: baseDisplayItems.reduce((acc, item) => ({
              ...acc,
              [item.name]: !item.alwaysVisible
            }), {}),
            toolsItems: baseToolsItems.reduce((acc, item) => ({
              ...acc,
              [item.name]: true
            }), {}),
            alwaysVisible: { 'Home': true, 'Settings': true, 'Help': true }
          };
          setSidebarSettings(defaultSettings);
        }

        // Fetch main settings
        const settingsRef = doc(db, 'companies', companyId, 'companySettings', 'info');
        const settingsSnap = await getDoc(settingsRef);
        if (settingsSnap.exists()) setFormData(prev => ({ ...prev, ...settingsSnap.data() }));

        // Fetch company profile
        const companyRef = doc(db, 'companies', companyId, 'companyProfile', 'info');
        const companySnap = await getDoc(companyRef);
        if (companySnap.exists()) setCompanyInfo(companySnap.data());

        // Fetch main settings
        const docRef = doc(db, 'companies', companyId, 'companySettings', 'main');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setCashiers(docSnap.data().cashiers || []);
        }

        const typesSnap = await getDocs(collection(db, 'companies', companyId, 'companySettings', 'inventory', 'productTypes'));
        const types = typesSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setProductTypes(types);

        const discountsSnap = await getDocs(collection(db, 'companies', companyId, 'companySettings', 'discounts', 'data'));
        const discountsList = discountsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setDiscounts(discountsList);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingPage(false);
      }
    };

    fetchSettings();
  }, [user]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
    setHasUnsavedChanges(true);
  };

  const handleSave = async () => {
    if (!user) return;
    setLoading(true);
    setMessage('');
    setError('');
    try {
      await setDoc(doc(db, 'companies', companyId, 'companySettings', 'info'), formData, { merge: true });
      setHasUnsavedChanges(false);
      setUnsavedChangesType('');
      
      // If we're in online ordering tab, also set the online ordering message
      if (activeTab === 'onlineOrdering') {
        setOnlineOrderingMessage('Settings saved successfully!');
        setTimeout(() => setOnlineOrderingMessage(''), 5000);
      }
      
      // If we're in general tab, also set the general message
      if (activeTab === 'general') {
        setGeneralMessage('Settings saved successfully!');
        setTimeout(() => setGeneralMessage(''), 5000);
      }
      
      // If we're in customer display tab, also set the customer display message
      if (activeTab === 'custDisp') {
        setCustomerDisplayMessage('Settings saved successfully!');
        setTimeout(() => setCustomerDisplayMessage(''), 5000);
      }
    } catch (err) {
      console.error(err);
      setError('Failed to save settings.');
    } finally {
      setLoading(false);
    }
  };

  const handleSaveTax = async () => {
    if (!user) return;
    setLoading(true);
    setMessage('');
    setError('');
    // Validation: require SST number on company profile before enabling any tax
    if (formData.taxEnabled && !companyInfo.sstNumber) {
      setError('Please add your SST Number in Company Profile before enabling tax.');
      setLoading(false);
      return;
    }
    // Validation: ensure a service tax rate when enabled
    if (formData.serviceTax10Enabled && (!formData.serviceTax10Rate || Number(formData.serviceTax10Rate) <= 0)) {
      setError('Please enter a service tax rate greater than 0%.');
      setLoading(false);
      return;
    }
    try {
      await setDoc(doc(db, 'companies', companyId, 'companySettings', 'info'), formData, { merge: true });
      setHasUnsavedChanges(false);
      setUnsavedChangesType('');
    } catch (err) {
      console.error(err);
      setError('Failed to save settings.');
    } finally {
      setLoading(false);
    }
  };

  const addCashier = async () => {
    if (cashiers.length >= limitations.cashier) {
      alert("You've reached the cashier limit for your current plan.");
      return;
    }
    if (!newCashierId || !newCashierName) return;
    if (cashiers.some(c => c.id === newCashierId.trim())) return;
  
    const newCashier = { id: newCashierId.trim(), name: newCashierName.trim() };
    const updated = [...cashiers, newCashier];
  
    setCashiers(updated);
    setNewCashierId('');
    setNewCashierName('');
  
    const docRef = doc(db, 'companies', companyId, 'companySettings', 'main');
    await setDoc(docRef, { cashiers: updated }, { merge: true });
  };
  
  const deleteCashier = async (idToDelete) => {
    if (!confirm("Are you sure you want to delete this cashier?")) return;
    const updated = cashiers.filter((c) => c.id !== idToDelete);
    setCashiers(updated);
  
    const docRef = doc(db, 'companies', companyId, 'companySettings', 'main');
    await setDoc(docRef, { cashiers: updated }, { merge: true });
  };

  const addProductType = async () => {
    if (productTypes.length >= limitations.productType) {
      alert("You've reached the product type limit for your current plan.");
      return;
    }
    if (!newProductType || !user) return;
    try {
      const newDoc = await addDoc(collection(db, 'companies', companyId, 'companySettings', 'inventory', 'productTypes'), { name: newProductType });
      setProductTypes(prev => [...prev, { id: newDoc.id, name: newProductType }]);
      setNewProductType('');
    } catch (err) {
      console.error('Error adding product type:', err);
    }
  };
  

  const deleteProductType = async (id) => {
    if (!user) return;
    if (!confirm("Are you sure you want to delete this product type?")) return;
    try {
      await deleteDoc(doc(db, 'companies', companyId, 'companySettings', 'inventory', 'productTypes', id));
      setProductTypes(prev => prev.filter(type => type.id !== id));
    } catch (err) {
      console.error('Error deleting product type:', err);
    }
  };

  const startEditProductType = (type) => {
    setEditingProductTypeId(type.id);
    setEditingProductTypeName(type.name);
  };

  const saveEditProductType = async () => {
    if (!editingProductTypeId || !editingProductTypeName.trim()) return;
    try {
      const oldType = productTypes.find(pt => pt.id === editingProductTypeId)?.name || '';
      const newTypeName = editingProductTypeName.trim();
      const docRef = doc(db, 'companies', companyId, 'companySettings', 'inventory', 'productTypes', editingProductTypeId);
      await updateDoc(docRef, { name: newTypeName });

      // Propagate type rename to existing products
      if (oldType && oldType !== newTypeName) {
        const productsRef = collection(db, 'companies', companyId, 'inventory', 'data', 'products');
        const q = query(productsRef, where('type', '==', oldType));
        const snap = await getDocs(q);
        if (!snap.empty) {
          const batch = writeBatch(db);
          snap.forEach((docSnap) => {
            batch.update(docSnap.ref, { type: newTypeName });
          });
          await batch.commit();
        }
      }

      setProductTypes(prev =>
        prev.map(pt => pt.id === editingProductTypeId ? { ...pt, name: newTypeName } : pt)
      );
    } catch (err) {
      console.error('Error updating product type:', err);
    } finally {
      setEditingProductTypeId(null);
      setEditingProductTypeName('');
    }
  };

  const cancelEditProductType = () => {
    setEditingProductTypeId(null);
    setEditingProductTypeName('');
  };

  const addDiscount = async () => {
    if (discounts.length >= limitations.discount) {
      alert("You've reached the discount limit for your current plan.");
      return;
    }
    if (!user) return;
    if (!newDiscountName && !newDiscountCode) return;

    const count = Number(newVoucherCount) || 1;
    const codes = [];
    const generateCode = () => {
      const rand = Math.random().toString(36).substring(2, 8).toUpperCase();
      return rand.padEnd(6, 'X').slice(0, 6);
    };

    for (let i = 0; i < count; i++) {
      if (shouldGenerateCode) {
        codes.push(generateCode());
      } else if (newDiscountCode) {
        codes.push(newDiscountCode.toUpperCase());
        break; // custom single code
      } else {
        codes.push(generateCode());
      }
    }

    const payload = {
      name: newDiscountName || prefix,
      value: newDiscountValue,
      codes,
      code: codes.length === 1 ? codes[0] : '',
      voucherCount: codes.length,
      generated: Boolean(shouldGenerateCode),
      redeemedCodes: [],
      createdAt: new Date().toISOString(),
    };

    if (newValidityStart) {
      payload.validFrom = new Date(newValidityStart).toISOString();
    }
    if (newValidityEnd) {
      payload.expiresAt = new Date(newValidityEnd).toISOString();
    }

    try {
      const newDoc = await addDoc(collection(db, 'companies', companyId, 'companySettings', 'discounts', 'data'), payload);
      setDiscounts(prev => [...prev, { id: newDoc.id, ...payload }]);
      setNewDiscountName('');
      setNewDiscountValue('');
      setNewVoucherCount('');
      setNewValidityStart('');
      setNewValidityEnd('');
      setNewDiscountCode('');
      setShouldGenerateCode(true);
    } catch (err) {
      console.error('Error adding discount:', err);
    }
  };

  const deleteDiscount = async (id) => {
    if (!user) return;
    if (!confirm("Are you sure you want to delete this discount?")) return;
    try {
      await deleteDoc(doc(db, 'companies', companyId, 'companySettings', 'discounts', 'data', id));
      setDiscounts(prev => prev.filter(discount => discount.id !== id));
    } catch (err) {
      console.error('Error deleting discount:', err);
    }
  };

  const exportCodesCsv = (discount) => {
    const codes = discount.codes || (discount.code ? [discount.code] : []);
    if (!codes.length) {
      alert('No codes to export for this discount.');
      return;
    }
    const rows = [['Code', 'Status']];
    const redeemed = discount.redeemedCodes || [];
    codes.forEach((c) => {
      const status = redeemed.includes(c) ? 'Redeemed' : 'Active';
      rows.push([c, status]);
    });
    const csvContent = rows.map(r => r.map(field => `"${String(field).replace(/"/g, '""')}"`).join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${discount.name || 'discount'}_codes.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  const saveEditDiscount = async () => {
    if (!editingDiscount || !user) return;
    const payload = {
      name: editDiscountName || editingDiscount.name,
      value: editDiscountValue || editingDiscount.value,
    };
    // Preserve existing codes/redeemed codes; code is not editable
    const existingCodes = editingDiscount.codes || (editingDiscount.code ? [editingDiscount.code] : []);
    const requestedCount = editVoucherCount ? Number(editVoucherCount) : (editingDiscount.voucherCount || existingCodes.length || 0);
    const generator = () => {
      const rand = Math.random().toString(36).substring(2, 8).toUpperCase();
      return rand.padEnd(6, 'X').slice(0, 6);
    };
    let updatedCodes = [...existingCodes];
    if (editingDiscount.generated && requestedCount > existingCodes.length) {
      const needed = requestedCount - existingCodes.length;
      for (let i = 0; i < needed; i++) {
        updatedCodes.push(generator());
      }
    }
    payload.codes = updatedCodes;
    payload.redeemedCodes = editingDiscount.redeemedCodes || [];
    payload.voucherCount = requestedCount || updatedCodes.length || 0;
    payload.code = payload.codes.length === 1 ? payload.codes[0] : '';
    if (editValidityStart) {
      payload.validFrom = new Date(editValidityStart).toISOString();
    } else {
      payload.validFrom = '';
    }
    if (editValidityEnd) {
      payload.expiresAt = new Date(editValidityEnd).toISOString();
    } else {
      payload.expiresAt = '';
    }
    try {
      const ref = doc(db, 'companies', companyId, 'companySettings', 'discounts', 'data', editingDiscount.id);
      await updateDoc(ref, payload);
      setDiscounts(prev =>
        prev.map(d => d.id === editingDiscount.id ? { ...d, ...payload } : d)
      );
      setEditingDiscount(null);
      setEditDiscountName('');
      setEditDiscountValue('');
      setEditValidityStart('');
      setEditValidityEnd('');
      setEditVoucherCount('');
    } catch (err) {
      console.error('Error updating discount:', err);
    }
  };

  const formatAmount = (amount) => `${formData.currencySymbol}${Number(amount).toFixed(formData.decimalPlaces)}`;
  const fullAddress = [companyInfo.street, companyInfo.postcode, companyInfo.city, companyInfo.state, companyInfo.country].filter(Boolean).join(', ');

  // Add this function to handle sidebar settings changes
  const handleSidebarSettingChange = async (section, item, value) => {
    try {
      const newSettings = {
        ...sidebarSettings,
        [section]: {
          ...sidebarSettings[section],
          [item]: value
        }
      };
      
      setSidebarSettings(newSettings);
      
      if (user) {
        const settingsRef = doc(db, 'companies', companyId, 'companySettings', 'sidebar');
        await setDoc(settingsRef, newSettings, { merge: true });
        setSaveMessage('Settings saved successfully!');
        setTimeout(() => setSaveMessage(''), 3000);
      }
    } catch (error) {
      console.error('Error updating sidebar settings:', error);
      setSaveMessage('Error saving settings');
      setTimeout(() => setSaveMessage(''), 3000);
    }
  };

  // Fetch products and bundles for online ordering
  const fetchProductsForOnlineOrdering = async () => {
    try {
      const productsSnap = await getDocs(collection(db, 'companies', companyId, 'inventory', 'data', 'products'));
      const productsList = productsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setProducts(productsList);

      const bundlesSnap = await getDocs(collection(db, 'companies', companyId, 'inventory', 'data', 'bundles'));
      const bundlesList = bundlesSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setBundles(bundlesList);

      // Initialize selected products state
      // Default to true if onlineOrdering field doesn't exist (first time)
      const selected = {};
      productsList.forEach(p => {
        selected[p.id] = p.onlineOrdering !== undefined ? p.onlineOrdering : true;
      });
      bundlesList.forEach(b => {
        selected[b.id] = b.onlineOrdering !== undefined ? b.onlineOrdering : true;
      });
      setSelectedProducts(selected);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const handleProductToggle = (productId) => {
    setSelectedProducts(prev => ({
      ...prev,
      [productId]: !prev[productId]
    }));
  };

  const handleTypeToggle = (typeName) => {
    const productsOfType = products.filter(p => p.type === typeName);
    const allSelected = productsOfType.every(p => selectedProducts[p.id]);
    
    const newSelected = { ...selectedProducts };
    productsOfType.forEach(p => {
      newSelected[p.id] = !allSelected;
    });
    setSelectedProducts(newSelected);
  };

  const toggleTypeExpansion = (typeName) => {
    setExpandedTypes(prev => ({
      ...prev,
      [typeName]: !prev[typeName]
    }));
  };

  const saveOnlineOrderingProducts = async () => {
    try {
      const batch = writeBatch(db);

      // Update products
      products.forEach(product => {
        const productRef = doc(db, 'companies', companyId, 'inventory', 'data', 'products', product.id);
        batch.update(productRef, { onlineOrdering: selectedProducts[product.id] || false });
      });

      // Update bundles
      bundles.forEach(bundle => {
        const bundleRef = doc(db, 'companies', companyId, 'inventory', 'data', 'bundles', bundle.id);
        batch.update(bundleRef, { onlineOrdering: selectedProducts[bundle.id] || false });
      });

      await batch.commit();
      setShowProductModal(false);
      setMessage('Online ordering products updated successfully!');
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      console.error('Error saving online ordering products:', error);
      setError('Failed to update products');
      setTimeout(() => setError(''), 3000);
    }
  };

  const downloadQRCode = () => {
    const svg = qrRef.current.querySelector('svg');
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL('image/png');
      
      const downloadLink = document.createElement('a');
      downloadLink.download = 'online-ordering-qr.png';
      downloadLink.href = pngFile;
      downloadLink.click();
    };
    
    img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)));
  };

  if (loadingPage) {
    return (
      <div className="w-full flex flex-col justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-purple-500 mb-4"></div>
        <span className="text-white">Loading company settings...</span>
      </div>
    );
  }


const handleFileUpload = async (e, type) => {
  const file = e.target.files[0];
  if (!file) return;

  const path = `companies/${companyId}/uploads/${type}.jpg`;
  const fileRef = ref(storage, path);

  try {
    if (type === "poster") setUploadingPoster(true);
    if (type === "duitnowQR") setUploadingQr(true);

    await uploadBytes(fileRef, file);
    const downloadURL = await getDownloadURL(fileRef);

    // Update Firestore
    const companyRef = doc(db, "companies", companyId, "companySettings", "info");
    await updateDoc(companyRef, {
      [`${type}Url`]: downloadURL,
    });
    setFormData(prev => ({ ...prev, [`${type}Url`]: downloadURL }));

    toast.success(`${type === "poster" ? "Poster" : "DuitNow QR"} uploaded successfully!`);
  } catch (err) {
    console.error(err);
    toast.error("Upload failed!");
  } finally {
    setUploadingPoster(false);
    setUploadingQr(false);
  }
};
  return (
    <div className="w-full max-w-6xl text-white mx-auto p-8 rounded-2xl shadow-md">
      <h2 className="text-3xl font-bold mb-6">Company Settings</h2>

      <div className="flex space-x-6 mb-8">
        <button className={`text-sm font-bold ${activeTab === 'general' ? 'text-white' : 'text-gray-400'}`} onClick={() => setActiveTab('general')}>General</button>
        <button className={`text-sm font-bold ${activeTab === 'tax' ? 'text-white' : 'text-gray-400'}`} onClick={() => setActiveTab('tax')}>Tax</button>
        <button className={`text-sm font-bold ${activeTab === 'cashiers' ? 'text-white' : 'text-gray-400'}`} onClick={() => setActiveTab('cashiers')}>Cashiers</button>
        <button className={`text-sm font-bold ${activeTab === 'productTypes' ? 'text-white' : 'text-gray-400'}`} onClick={() => setActiveTab('productTypes')}>Product Types</button>
        <button className={`text-sm font-bold ${activeTab === 'discounts' ? 'text-white' : 'text-gray-400'}`} onClick={() => setActiveTab('discounts')}>Discounts</button>
        <button className={`text-sm font-bold ${activeTab === 'sidebar' ? 'text-white' : 'text-gray-400'}`} onClick={() => setActiveTab('sidebar')}>Sidebar</button>
        <button className={`text-sm font-bold ${activeTab === 'onlineOrdering' ? 'text-white' : 'text-gray-400'}`} onClick={() => setActiveTab('onlineOrdering')}>Online Ordering</button>
      <button className={`text-sm font-bold ${activeTab === 'sidebar' ? 'text-white' : 'text-gray-400'}`} onClick={() => setActiveTab('custDisp')}>Customer Display</button>
      </div> 

      {activeTab === 'general' && (
        <>
          <div className="space-y-6">
            <div>
              <label className="block text-sm mb-2 text-gray-400">Receipt Footer</label>
              <textarea name="receiptFooter" placeholder="e.g. Show this receipt to get discount on next pruchase" value={formData.receiptFooter} onChange={handleChange} rows="2" className="w-full bg-[#1f1f1f] text-white rounded-lg px-4 py-3" />
            </div>
            <div>
              <label className="block text-sm mb-2 text-gray-400">Thank You Note <span className="text-red-500">*</span></label>
              <textarea name="thankYouNote" placeholder="Thank You Note" required value={formData.thankYouNote} onChange={handleChange} rows="2" className="w-full bg-[#1f1f1f] text-white rounded-lg px-4 py-3" />
            </div>
            <div>
              <label className="block text-sm mb-2 text-gray-400">Currency Symbol</label>
              <input name="currencySymbol" value={formData.currencySymbol} onChange={handleChange} className="w-full bg-[#1f1f1f] text-white rounded-lg px-4 py-3" />
            </div>
            <div>
              <label className="block text-sm mb-2 text-gray-400">Decimal Places</label>
              <input type="number" name="decimalPlaces" value={formData.decimalPlaces} onChange={handleChange} min="0" max="4" className="w-full bg-[#1f1f1f] text-white rounded-lg px-4 py-3" />
            </div>
            <div>
              <label className="block text-sm mb-2 text-gray-400">Stall Type <span className="text-red-500">*</span></label>
              <select
                name="stallType"
                value={formData.stallType}
                onChange={handleChange}
                className="w-full bg-[#1f1f1f] text-white rounded-lg px-4 py-3"
                required
              >
                <option value="fnb">Food & Beverage (FNB)</option>
                <option value="non-fnb">Non-Food (Retail, Service, etc)</option>
              </select>
            </div>
            <button onClick={() => setShowPreview(true)} className="bg-gray-700 hover:bg-gray-600 px-6 py-3 rounded-lg font-bold text-white">Preview Receipt</button>
          </div>
          {hasUnsavedChanges && (
            <div className="mt-4 text-red-400 text-sm">
              You have unsaved changes. Click "Save Changes" to apply them.
            </div>
          )}
          <div className="flex gap-4 mt-8">
            <button onClick={() => {
              setGeneralSaving(true);
              handleSave().finally(() => {
                setGeneralSaving(false);
              });
            }} disabled={generalSaving || !formData.thankYouNote} className="bg-purple-600 hover:bg-purple-700 px-6 py-3 rounded-lg font-bold text-white disabled:opacity-50">
              {generalSaving ? (
                <span className="flex items-center gap-2">
                  <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Saving...
                </span>
              ) : (
                'Save Changes'
              )}
            </button>
            {generalMessage && (
              <span className="text-green-400 font-medium animate-fade-in flex items-center">
                {generalMessage}
              </span>
            )}
          </div>
        </>
      )}

      {activeTab === 'tax' && (
        <div className="space-y-6">
          <h3 className="text-xl font-bold mb-4">Tax</h3>
          <div className="flex flex-col gap-6 mb-4 max-w-md">
            {/* Master Enable Tax */}
            <div className="flex items-center justify-between mb-2">
              <label className="text-sm text-gray-400">Enable Tax</label>
              <button type="button" onClick={() => {
  // Require SST number in company profile before enabling tax
  if (!formData.taxEnabled && !companyInfo.sstNumber) {
    alert('Please add your SST Number in Company Profile before enabling tax.');
    return;
  }
  if (formData.taxEnabled) {
    setFormData(prev => ({
      ...prev,
      taxEnabled: false,
      sst6Enabled: false,
      sst8Enabled: false,
      serviceTax10Enabled: false,
    }));
  } else {
    setFormData(prev => ({
      ...prev,
      taxEnabled: true,
    }));
  }
  setHasUnsavedChanges(true);
}}
               className={`w-12 h-6 flex items-center rounded-full p-1 duration-300 ${formData.taxEnabled ? 'bg-purple-600' : 'bg-gray-400'}`}>
                {/*onClick={() => window.alert('This feature is not compliance with LHDN requirements yet.')}*/}
                <div className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ${formData.taxEnabled ? 'translate-x-6' : ''}`} />
              </button>
            </div>
            {/* SST 6% */}
            <div className="flex items-center justify-between mb-2">
              <label className="text-sm text-gray-400">Enable SST 6%</label>
              <button type="button" disabled={!formData.taxEnabled}   onClick={() => {
    setFormData(prev => ({
      ...prev,
      sst6Enabled: !prev.sst6Enabled,
      sst8Enabled: prev.sst6Enabled ? prev.sst8Enabled : false // If enabling sst6, disable sst8
    }));
    setHasUnsavedChanges(true);
  }} className={`w-12 h-6 flex items-center rounded-full p-1 duration-300 ${formData.sst6Enabled ? 'bg-purple-600' : 'bg-gray-400'} ${!formData.taxEnabled ? 'opacity-50 cursor-not-allowed' : ''}`}>  
                <div className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ${formData.sst6Enabled ? 'translate-x-6' : ''}`} />
              </button>
            </div>
            {/* SST 8% */}
            <div className="flex items-center justify-between mb-2">
              <label className="text-sm text-gray-400">Enable SST 8%</label>
              <button type="button" disabled={!formData.taxEnabled}   onClick={() => {
    setFormData(prev => ({
      ...prev,
      sst8Enabled: !prev.sst8Enabled,
      sst6Enabled: prev.sst8Enabled ? prev.sst6Enabled : false // If enabling sst8, disable sst6
    }));
    setHasUnsavedChanges(true);
  }} className={`w-12 h-6 flex items-center rounded-full p-1 duration-300 ${formData.sst8Enabled ? 'bg-purple-600' : 'bg-gray-400'} ${!formData.taxEnabled ? 'opacity-50 cursor-not-allowed' : ''}`}>  
                <div className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ${formData.sst8Enabled ? 'translate-x-6' : ''}`} />
              </button>
            </div>
            <div className="flex items-center justify-between mb-2">
              <label className="text-sm text-gray-400">Enable Service Tax</label>
              <button type="button" disabled={!formData.taxEnabled} onClick={() => {
    setFormData(prev => ({ ...prev, serviceTax10Enabled: !prev.serviceTax10Enabled }));
    setHasUnsavedChanges(true);
  }} className={`w-12 h-6 flex items-center rounded-full p-1 duration-300 ${formData.serviceTax10Enabled ? 'bg-purple-600' : 'bg-gray-400'} ${!formData.taxEnabled ? 'opacity-50 cursor-not-allowed' : ''}`}>  
                <div className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ${formData.serviceTax10Enabled ? 'translate-x-6' : ''}`} />
              </button>
            </div>
            {formData.serviceTax10Enabled && (
              <div className="mb-2">
                <input
                  type="number"
                  name="serviceTax10Rate"
                  placeholder="Enter Service Tax Rate (%)"
                  value={formData.serviceTax10Rate}
                  onChange={handleChange}
                  min="0"
                  step="0.01"
                  className="w-full bg-[#1f1f1f] text-white rounded-lg px-4 py-3"
                />
                {!formData.serviceTax10Rate && <p className="text-red-400 text-xs mt-1">Service tax rate is required.</p>}
              </div>
            )}
            {hasUnsavedChanges && (
              <div className="mt-4 text-red-400 text-sm">
                You have unsaved changes. Click "Save Changes" to apply them.
              </div>
            )}
            <div className="flex gap-4 mt-8">
            <button onClick={handleSaveTax} disabled={loading} className="bg-purple-600 hover:bg-purple-700 px-6 py-3 rounded-lg font-bold text-white disabled:opacity-50">
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
          </div>  
          </div>
        </div>
      )}

{activeTab === 'custDisp' && (
  <div className="space-y-8">
    <div className="bg-[#1f1f1f] p-6 rounded-2xl shadow-lg flex items-center justify-between">
      <div>
        <h3 className="text-xl font-bold text-white">Customer Display</h3>
        <p className="text-sm text-gray-400">Allow cashiers to open the customer-facing display window.</p>
      </div>
      <button
        type="button"
        onClick={() => {
          setFormData(prev => ({ ...prev, customerDisplayEnabled: !prev.customerDisplayEnabled }));
          setHasUnsavedChanges(true);
        }}
        className={`w-14 h-8 flex items-center rounded-full p-1 transition ${
          formData.customerDisplayEnabled ? 'bg-purple-600' : 'bg-gray-600'
        }`}
      >
        <div
          className={`bg-white w-6 h-6 rounded-full shadow-md transform duration-300 ${
            formData.customerDisplayEnabled ? 'translate-x-6' : ''
          }`}
        />
      </button>
    </div>

    {/* Poster Upload */}
    <div className="bg-[#1f1f1f] p-6 rounded-2xl shadow-lg">
      <h3 className="text-xl font-bold mb-4 text-white">Customer Display Poster</h3>
      <label
        htmlFor="posterUpload"
        className="border-2 border-dashed border-gray-500 hover:border-purple-500 transition cursor-pointer flex flex-col items-center justify-center p-8 rounded-xl text-gray-400 hover:text-purple-400"
      >
        <p className="text-sm">Click to upload or drag and drop</p>
        <p className="font-semibold text-purple-400">Poster Image</p>
        <input
          id="posterUpload"
          type="file"
          accept="image/*"
          className="hidden"
          onChange={(e) => handleFileUpload(e, "poster")}
        />
      </label>
      {uploadingPoster && (
        <p className="text-sm text-yellow-400 mt-2">Uploading poster...</p>
      )}
      {formData.posterUrl && (
        <div className="mt-4">
          <p className="text-xs text-gray-400 mb-2">Current poster</p>
          <img
            src={formData.posterUrl}
            alt="Customer display poster"
            className="w-full max-w-md rounded-lg border border-gray-700"
          />
        </div>
      )}
    </div>

    {/* DuitNow QR Upload */}
    <div className="bg-[#1f1f1f] p-6 rounded-2xl shadow-lg">
      <h3 className="text-xl font-bold mb-4 text-white">DuitNow QR</h3>
      <label
        htmlFor="qrUpload"
        className="border-2 border-dashed border-gray-500 hover:border-green-500 transition cursor-pointer flex flex-col items-center justify-center p-8 rounded-xl text-gray-400 hover:text-green-400"
      >
        <p className="text-sm">Click to upload or drag and drop</p>
        <p className="font-semibold text-green-400">DuitNow QR Code</p>
        <input
          id="qrUpload"
          type="file"
          accept="image/*"
          className="hidden"
          onChange={(e) => handleFileUpload(e, "duitnowQR")}
        />
      </label>
      {uploadingQr && (
        <p className="text-sm text-yellow-400 mt-2">Uploading DuitNow QR...</p>
      )}
      {formData.duitnowQRUrl && (
        <div className="mt-4">
          <p className="text-xs text-gray-400 mb-2">Current DuitNow QR</p>
          <img
            src={formData.duitnowQRUrl}
            alt="DuitNow QR code"
            className="w-full max-w-md rounded-lg border border-gray-700"
          />
        </div>
      )}
    </div>

    {hasUnsavedChanges && (
      <div className="mt-4 text-red-400 text-sm">
        You have unsaved changes. Click "Save Changes" to apply them.
      </div>
    )}

    <div className="flex gap-4">
      <button
        onClick={() => {
          setCustomerDisplaySaving(true);
          handleSave().finally(() => {
            setCustomerDisplaySaving(false);
          });
        }}
        disabled={customerDisplaySaving}
        className="bg-purple-600 hover:bg-purple-700 px-6 py-3 rounded-lg font-bold text-white disabled:opacity-50"
      >
        {customerDisplaySaving ? (
          <span className="flex items-center gap-2">
            <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Saving...
          </span>
        ) : (
          'Save Changes'
        )}
      </button>
      {customerDisplayMessage && (
        <span className="text-green-400 font-medium animate-fade-in flex items-center">
          {customerDisplayMessage}
        </span>
      )}
    </div>
  </div>
)}

      {activeTab === 'cashiers' && (
        <div className="space-y-6">
          <h3 className="text-xl font-bold mb-4">Cashiers</h3>

          <div className="flex flex-col md:flex-row gap-4 mb-4">
            <input
              type="text"
              value={newCashierId}
              onChange={(e) => setNewCashierId(e.target.value)}
              placeholder="Cashier ID"
              className="bg-[#1f1f1f] text-white rounded-lg px-4 py-3 w-full"
            />
            <input
              type="text"
              value={newCashierName}
              onChange={(e) => setNewCashierName(e.target.value)}
              placeholder="Cashier Name"
              className="bg-[#1f1f1f] text-white rounded-lg px-4 py-3 w-full"
            />
            <button
              onClick={addCashier}
              disabled={!newCashierId.trim() || !newCashierName.trim()}
              className={`px-4 py-2 rounded-lg font-bold ${
                !newCashierId.trim() || !newCashierName.trim()
                  ? 'bg-gray-600 cursor-not-allowed'
                  : 'bg-green-600 hover:bg-green-700'
              } text-white`}
            >
              Add
            </button>
          </div>

          <ul className="space-y-2">
            {cashiers.map((cashier) => (
              <li key={cashier.id} className="flex justify-between items-center bg-[#1f1f1f] px-4 py-2 rounded-lg">
                <span>{cashier.name} <span className="text-gray-400 text-xs">({cashier.id})</span></span>
                <button
                  onClick={() => deleteCashier(cashier.id)}
                  className="text-red-400 hover:text-red-600 text-sm"
                >
                  Delete
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}

      {activeTab === 'productTypes' && (
        <div className="space-y-6">
          <h3 className="text-xl font-bold mb-4">Product Types</h3>
          <div className="flex gap-4 mb-4">
            <input type="text" value={newProductType} onChange={e => setNewProductType(e.target.value)} placeholder="New Product Type" className="bg-[#1f1f1f] text-white rounded-lg px-4 py-3 w-full" />
            <button onClick={addProductType} disabled={!newProductType.trim()} className={`px-4 py-2 rounded-lg font-bold ${
                !newProductType.trim()
                  ? 'bg-gray-600 cursor-not-allowed'
                  : 'bg-green-600 hover:bg-green-700'
              } text-white`}>
              Add
            </button>
          </div>
          <ul className="space-y-2">
            {productTypes.map(type => (
              <li key={type.id} className="flex justify-between items-center bg-[#1f1f1f] px-4 py-2 rounded-lg">
                {editingProductTypeId === type.id ? (
                  <div className="flex items-center gap-2 w-full">
                    <input
                      className="bg-[#111] text-white rounded px-2 py-1 flex-1"
                      value={editingProductTypeName}
                      onChange={(e) => setEditingProductTypeName(e.target.value)}
                    />
                    <button
                      onClick={saveEditProductType}
                      className="text-green-400 hover:text-green-600 text-sm"
                    >
                      Save
                    </button>
                    <button
                      onClick={cancelEditProductType}
                      className="text-gray-400 hover:text-gray-600 text-sm"
                    >
                      Cancel
                    </button>
                  </div>
                ) : (
                  <>
                    <span>{type.name}</span>
                    <div className="flex items-center gap-3">
                      <button
                        onClick={() => startEditProductType(type)}
                        className="text-blue-400 hover:text-blue-600 text-sm"
                      >
                        Edit
                      </button>
                      <button onClick={() => deleteProductType(type.id)} className="text-red-400 hover:text-red-600 text-sm">Delete</button>
                    </div>
                  </>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}

      {activeTab === 'discounts' && (
        <div className="space-y-6">
      <h3 className="text-xl font-bold mb-4">Discount Settings</h3>
      <div className="flex gap-4 mb-4">
        <div className="flex-1 space-y-3">
          <div className="flex gap-3">
            <input type="text" placeholder="Discount Name (e.g. First Customer)" value={newDiscountName} onChange={e => setNewDiscountName(e.target.value)} className="bg-[#1f1f1f] text-white rounded-lg px-4 py-3 w-1/2" />
            <input type="text" placeholder="Value (e.g., 10% or 5.00)" value={newDiscountValue} onChange={e => setNewDiscountValue(e.target.value)} className="bg-[#1f1f1f] text-white rounded-lg px-4 py-3 w-1/2" />
          </div>
          <div className="flex gap-3">
            <input
              type="number"
              min="1"
              placeholder="How many vouchers?"
              value={newVoucherCount}
              onChange={(e) => setNewVoucherCount(e.target.value)}
              className="bg-[#1f1f1f] text-white rounded-lg px-4 py-3 w-1/2"
            />
            <label className="flex items-center gap-2 text-sm text-gray-300">
              <input type="checkbox" checked={shouldGenerateCode} onChange={(e) => setShouldGenerateCode(e.target.checked)} />
              Generate code automatically
            </label>
            {!shouldGenerateCode && (
              <input
                type="text"
                placeholder="Custom code (optional)"
                value={newDiscountCode}
                onChange={(e) => setNewDiscountCode(e.target.value.toUpperCase())}
                className="bg-[#1f1f1f] text-white rounded-lg px-4 py-3 flex-1"
              />
            )}
          </div>
          <div className="flex gap-3">
            <input
              type="date"
              placeholder="Valid from" 
              value={newValidityStart}
              onChange={(e) => setNewValidityStart(e.target.value)}
              className="bg-[#1f1f1f] text-white rounded-lg px-4 py-3 w-1/2"
            />
            <input
              type="date"
              placeholder="Valid until"
              value={newValidityEnd}
              onChange={(e) => setNewValidityEnd(e.target.value)}
              className="bg-[#1f1f1f] text-white rounded-lg px-4 py-3 w-1/2"
            />
          </div>
        </div>
        <button onClick={addDiscount} disabled={(!newDiscountName.trim() && !newDiscountCode.trim()) || !newDiscountValue.trim()} className={`px-4 py-2 rounded-lg font-bold ${
            (!newDiscountName.trim() && !newDiscountCode.trim()) || !newDiscountValue.trim()
              ? 'bg-gray-600 cursor-not-allowed'
              : 'bg-green-600 hover:bg-green-700'
          } text-white `}>  
              Add
            </button>
          </div>
          <ul className="space-y-2">
            {discounts.map(discount => (
              <li
                key={discount.id}
                className="flex flex-col gap-1 bg-[#1f1f1f] px-4 py-2 rounded-lg"
              >
                <div className="flex justify-between items-center">
                  <div className="text-sm">
                    <div className="font-semibold">{discount.name}</div>
                    <div className="text-gray-300">
                      {discount.value && discount.value.toString().includes('%') ? discount.value : `RM ${discount.value}`}
                    </div>
                    <div className="text-xs text-gray-400">
                      Vouchers: {discount.voucherCount ?? discount.codes?.length ?? 0}
                    </div>
                    {discount.codes && discount.codes.length > 0 ? (
                      <details className="text-xs text-gray-400 mt-1">
                        <summary className="cursor-pointer">
                          Codes ({discount.codes.length}) | Redeemed {discount.redeemedCodes ? discount.redeemedCodes.length : 0}
                        </summary>
                        <div className="mt-1 space-y-0.5">
                          {discount.codes.map((c, idx) => {
                            const redeemed = discount.redeemedCodes?.includes(c);
                            const redacted = redeemed ? c.replace(/.(?=.{2})/g, '*') : c;
                            return (
                              <div key={idx} className={`break-all ${redeemed ? 'text-gray-500' : ''}`}>
                                {redacted}
                              </div>
                            );
                          })}
                        </div>
                      </details>
                    ) : (
                      discount.code && (
                        <div className="text-xs text-gray-400">
                          Code: {discount.redeemedCodes?.includes(discount.code) ? discount.code.replace(/.(?=.{2})/g, '*') : discount.code}
                        </div>
                      )
                    )}
                    {(discount.validFrom || discount.expiresAt) && (
                      <div className="text-xs text-gray-400">
                        {(() => {
                          const fmt = (d) => {
                            if (!d) return '—';
                            const date = new Date(d);
                            return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
                          };
                          return `Valid from ${fmt(discount.validFrom)} until ${fmt(discount.expiresAt)}`;
                        })()}
                      </div>
                    )}
                  </div>
                  <div className="flex items-center gap-3">
                    <button
                      onClick={() => {
                        setEditingDiscount(discount);
                        setEditDiscountName(discount.name);
                        setEditDiscountValue(discount.value);
                        setEditValidityStart(discount.validFrom ? discount.validFrom.split('T')[0] : '');
                        setEditValidityEnd(discount.expiresAt ? discount.expiresAt.split('T')[0] : '');
                        setEditVoucherCount(discount.voucherCount || discount.codes?.length || '');
                      }}
                      className="text-blue-400 hover:text-blue-600 text-sm"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => exportCodesCsv(discount)}
                      className="text-green-400 hover:text-green-600 text-sm"
                    >
                      Export CSV
                    </button>
                    <button
                      onClick={() => deleteDiscount(discount.id)}
                      className="text-red-400 hover:text-red-600 text-sm"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </li>
            ))}
          </ul>

          {editingDiscount && (
            <div className="mt-4 border border-gray-700 rounded-lg p-4 bg-[#111] space-y-3">
              <h4 className="font-semibold text-white">Edit Discount</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <label className="text-sm text-gray-300 flex flex-col gap-1">
                  <span>Name</span>
                  <input
                    type="text"
                    value={editDiscountName}
                    onChange={(e) => setEditDiscountName(e.target.value)}
                    className="bg-[#1f1f1f] text-white rounded-lg px-3 py-2"
                  />
                </label>
                <label className="text-sm text-gray-300 flex flex-col gap-1">
                  <span>Value (10% or 5.00)</span>
                  <input
                    type="text"
                    value={editDiscountValue}
                    onChange={(e) => setEditDiscountValue(e.target.value)}
                    className="bg-[#1f1f1f] text-white rounded-lg px-3 py-2"
                  />
                </label>
                <label className="text-sm text-gray-300 flex flex-col gap-1">
                  <span>Voucher count</span>
                  <input
                    type="number"
                    min="1"
                    value={editVoucherCount}
                    onChange={(e) => setEditVoucherCount(e.target.value)}
                    className="bg-[#1f1f1f] text-white rounded-lg px-3 py-2"
                  />
                </label>
              </div>
            <div className="flex items-center gap-3 flex-wrap">
              <label className="text-sm text-gray-300 flex flex-col gap-1">
                <span>Valid from</span>
                <input
                  type="date"
                    value={editValidityStart}
                    onChange={(e) => setEditValidityStart(e.target.value)}
                    className="bg-[#1f1f1f] text-white rounded-lg px-3 py-2"
                  />
                </label>
                <label className="text-sm text-gray-300 flex flex-col gap-1">
                  <span>Valid until</span>
                  <input
                    type="date"
                    value={editValidityEnd}
                    onChange={(e) => setEditValidityEnd(e.target.value)}
                    className="bg-[#1f1f1f] text-white rounded-lg px-3 py-2"
                  />
                </label>
              </div>
              <div className="flex gap-3">
                <button
                  onClick={saveEditDiscount}
                  className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg"
                >
                  Save
                </button>
                <button
                  onClick={() => setEditingDiscount(null)}
                  className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg"
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {activeTab === 'sidebar' && (
        <div className="space-y-1">
          <div className="flex justify-between items-center mb-6">
            <div>
              <h3 className="text-xl font-bold">Sidebar Menu Settings</h3>
              <p className="text-sm text-gray-400">Toggle menu items to show/hide them in the sidebar. Note: Some essential items cannot be hidden.</p>
            </div>
            <div className="flex items-center space-x-4">
              {saveMessage && (
                <div className="bg-green-900/50 text-green-400 px-4 py-2 rounded-md text-sm">
                  {saveMessage}
                </div>
              )}
              <button
                onClick={() => window.location.reload()}
                className="bg-purple-600 hover:bg-purple-700 px-4 py-2 rounded-lg text-white font-medium flex items-center space-x-2"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" />
                </svg>
                <span>Refresh</span>
              </button>
            </div>
          </div>
          <div className="space-y-8">
            {/* Navigation Items */}
            <div>
              <h4 className="text-md font-semibold mb-3 text-gray-300">Navigation</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {Object.entries(sidebarSettings.navItems).filter(([item]) => item !== 'Table').map(([item, isVisible]) => (
                  <div key={item} className={`flex items-center p-3 rounded-lg ${sidebarSettings.alwaysVisible[item] ? 'bg-[#1f1f1f] opacity-75' : 'bg-[#1f1f1f] hover:bg-[#2a2a2a]'} transition`}>
                    <input
                      type="checkbox"
                      checked={isVisible}
                      disabled={sidebarSettings.alwaysVisible[item]}
                      onChange={(e) => !sidebarSettings.alwaysVisible[item] && handleSidebarSettingChange('navItems', item, e.target.checked)}
                      className={`form-checkbox h-5 w-5 text-purple-600 rounded focus:ring-purple-500 ${sidebarSettings.alwaysVisible[item] ? 'bg-gray-600' : ''}`}
                    />
                    <span className={`ml-2 ${sidebarSettings.alwaysVisible[item] ? 'text-gray-400' : 'text-gray-200'}`}>
                      {item}
                      {sidebarSettings.alwaysVisible[item] && (
                        <span className="ml-2 text-xs bg-gray-600 text-gray-300 px-2 py-0.5 rounded">
                          Always visible
                        </span>
                      )}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Finance Items */}
            <div>
              <h4 className="text-md font-semibold mb-3 text-gray-300">Finance</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {Object.entries(sidebarSettings.financeItems).map(([item, isVisible]) => (
                  <label key={item} className="flex items-center space-x-2 p-3 bg-[#1f1f1f] rounded-lg hover:bg-[#2a2a2a] transition">
                    <input
                      type="checkbox"
                      checked={isVisible}
                      onChange={(e) => handleSidebarSettingChange('financeItems', item, e.target.checked)}
                      className="form-checkbox h-5 w-5 text-purple-600 rounded focus:ring-purple-500"
                    />
                    <span className="text-gray-200">{item}</span>
                  </label>
                ))}
              </div>
            </div>

            {/* Display Items */}
            <div>
              <h4 className="text-md font-semibold mb-3 text-gray-300">Display</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {Object.entries(sidebarSettings.displayItems).map(([item, isVisible]) => (
                  <label key={item} className="flex items-center space-x-2 p-3 bg-[#1f1f1f] rounded-lg hover:bg-[#2a2a2a] transition">
                    <input
                      type="checkbox"
                      checked={isVisible}
                      onChange={(e) => handleSidebarSettingChange('displayItems', item, e.target.checked)}
                      className="form-checkbox h-5 w-5 text-purple-600 rounded focus:ring-purple-500"
                    />
                    <span className="text-gray-200">{item}</span>
                  </label>
                ))}
              </div>
            </div>

            {/* Tools Items */}
            <div>
              <h4 className="text-md font-semibold mb-3 text-gray-300">Tools</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {Object.entries(sidebarSettings.toolsItems)
                  // Filter out items that are marked as always visible
                  .filter(([item]) => !sidebarSettings.alwaysVisible?.[item])
                  .map(([item, isVisible]) => (
                    <label key={item} className="flex items-center space-x-2 p-3 bg-[#1f1f1f] rounded-lg hover:bg-[#2a2a2a] transition">
                      <input
                        type="checkbox"
                        checked={isVisible}
                        onChange={(e) => handleSidebarSettingChange('toolsItems', item, e.target.checked)}
                        className="form-checkbox h-5 w-5 text-purple-600 rounded focus:ring-purple-500"
                      />
                      <span className="text-gray-200">{item}</span>
                    </label>
                  ))}
                
                {/* Always visible items - Settings */}
                <div className="flex items-center p-3 bg-[#1f1f1f] rounded-lg opacity-75">
                  <input
                    type="checkbox"
                    checked={true}
                    disabled
                    className="form-checkbox h-5 w-5 text-purple-600 rounded focus:ring-purple-500 bg-gray-600"
                  />
                  <span className="ml-2 text-gray-400">Settings</span>
                  <span className="ml-2 text-xs bg-gray-600 text-gray-300 px-2 py-0.5 rounded">
                    Always visible
                  </span>
                </div>

                {/* Always visible items - Help */}
                <div className="flex items-center p-3 bg-[#1f1f1f] rounded-lg opacity-75">
                  <input
                    type="checkbox"
                    checked={true}
                    disabled
                    className="form-checkbox h-5 w-5 text-purple-600 rounded focus:ring-purple-500 bg-gray-600"
                  />
                  <span className="ml-2 text-gray-400">Help</span>
                  <span className="ml-2 text-xs bg-gray-600 text-gray-300 px-2 py-0.5 rounded">
                    Always visible
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'onlineOrdering' && (
        <div className="space-y-6">
          <h3 className="text-xl font-bold mb-4">Online Ordering Settings</h3>
          
          <div className="bg-[#1f1f1f] p-6 rounded-lg">
            <h4 className="text-lg font-semibold mb-4">Online Ordering Link & QR Code</h4>
            <p className="text-sm text-gray-400 mb-4">
              Share this link with your customers to allow them to place orders online.
            </p>
            
            <div className="flex flex-col lg:flex-row gap-6">
              {/* QR Code Display */}
              <div className="flex flex-col items-center">
                <div ref={qrRef} className="bg-white p-4 rounded-lg mb-3">
                  <QRCode value={onlineOrderingLink} size={200} />
                </div>
                <button
                  onClick={downloadQRCode}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors text-sm flex items-center gap-2"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                  Download QR Code
                </button>
              </div>

              {/* Link Section */}
              <div className="flex-1">
                <label className="block text-sm text-gray-400 mb-2">Public Link</label>
                <div className="flex gap-2">
                  <input
                    type="text"
                    readOnly
                    value={onlineOrderingLink}
                    className="flex-1 bg-[#2d2d2d] text-white px-4 py-2 rounded-lg focus:outline-none text-sm"
                    onClick={(e) => e.target.select()}
                  />
                  <button
                    onClick={async () => {
                      try {
                        await navigator.clipboard.writeText(onlineOrderingLink);
                        setIsLinkCopied(true);
                        setTimeout(() => setIsLinkCopied(false), 2000);
                      } catch (err) {
                        console.error('Failed to copy text: ', err);
                      }
                    }}
                    className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg transition-colors text-sm flex items-center gap-2"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                    </svg>
                    {isLinkCopied ? 'Copied!' : 'Copy'}
                  </button>
                </div>
                <div className="flex items-center space-x-2 text-sm text-gray-400 mt-3">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span>Make sure to select items available for online ordering below.</span>
                </div>
              </div>
            </div>
            
            <div className="mt-8 border-t border-gray-700 pt-6">
              <h4 className="text-lg font-semibold mb-4">Online Ordering Settings</h4>
              <div className="space-y-4">
                {/* Enable Online Ordering Toggle */}
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <h5 className="font-medium">Enable Online Ordering</h5>
                    <p className="text-sm text-gray-400">Allow customers to place orders online</p>
                  </div>
                  <button
                    type="button"
                    onClick={() => {
                      setFormData(prev => ({
                        ...prev,
                        onlineOrderingEnabled: !formData.onlineOrderingEnabled
                      }));
                      setHasUnsavedChanges(true);
                      setUnsavedChangesType('settings');
                    }}
                    className={`w-12 h-6 flex items-center rounded-full p-1 duration-300 ${formData.onlineOrderingEnabled ? 'bg-purple-600' : 'bg-gray-600'}`}
                  >
                    <div className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ${formData.onlineOrderingEnabled ? 'translate-x-6' : ''}`} />
                  </button>
                </div>

                {/* Enable Pre-orders */}
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <h5 className="font-medium">Enable Pre-orders</h5>
                    <p className="text-sm text-gray-400">Let customers schedule orders in advance.</p>
                  </div>
                  <button
                    type="button"
                    onClick={() => {
                      setFormData(prev => ({
                        ...prev,
                        enablePreOrders: !formData.enablePreOrders
                      }));
                      setHasUnsavedChanges(true);
                      setUnsavedChangesType('settings');
                    }}
                    className={`w-12 h-6 flex items-center rounded-full p-1 duration-300 ${formData.enablePreOrders ? 'bg-purple-600' : 'bg-gray-600'}`}
                  >
                    <div className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ${formData.enablePreOrders ? 'translate-x-6' : ''}`} />
                  </button>
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <h5 className="font-medium">Enable Pickup</h5>
                    <p className="text-sm text-gray-400">Allow customers to choose pickup orders.</p>
                  </div>
                  <button
                    type="button"
                    onClick={() => {
                      setFormData(prev => ({
                        ...prev,
                        enablePickup: !formData.enablePickup
                      }));
                      setHasUnsavedChanges(true);
                      setUnsavedChangesType('settings');
                    }}
                    className={`w-12 h-6 flex items-center rounded-full p-1 duration-300 ${formData.enablePickup !== false ? 'bg-purple-600' : 'bg-gray-600'}`}
                  >
                    <div className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ${formData.enablePickup !== false ? 'translate-x-6' : ''}`} />
                  </button>
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <h5 className="font-medium">Enable Delivery</h5>
                    <p className="text-sm text-gray-400">Allow customers to choose delivery and enter their address.</p>
                  </div>
                  <button
                    type="button"
                    onClick={() => {
                      setFormData(prev => ({
                        ...prev,
                        enableDelivery: !formData.enableDelivery
                      }));
                      setHasUnsavedChanges(true);
                      setUnsavedChangesType('settings');
                    }}
                    className={`w-12 h-6 flex items-center rounded-full p-1 duration-300 ${formData.enableDelivery ? 'bg-purple-600' : 'bg-gray-600'}`}
                  >
                    <div className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ${formData.enableDelivery ? 'translate-x-6' : ''}`} />
                  </button>
                </div>

                {/* Manage Online Ordering Items */}
                <div className="flex items-center justify-between bg-[#2a2a2a] p-4 rounded-lg">
                  <div className="flex-1">
                    <h5 className="font-medium">Manage Online Ordering Items</h5>
                    <p className="text-sm text-gray-400">Select which products and bundles are available for online ordering</p>
                  </div>
                  <button
                    onClick={() => {
                      fetchProductsForOnlineOrdering();
                      setShowProductModal(true);
                    }}
                    className="text-gray-400 hover:text-white transition-colors p-2 hover:bg-[#333] rounded-lg"
                    title="Edit Available Items"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                  </button>
                </div>

                <div className="bg-[#2a2a2a] p-4 rounded-lg space-y-4">
                  <div>
                    <h5 className="font-medium">Stripe API Key</h5>
                    <p className="text-sm text-gray-400">Add your Stripe secret key to accept online payments.</p>
                  </div>
                  <div className="space-y-3">
                    <div>
                      <label className="text-xs text-gray-400 block mb-1">Stripe Secret Key</label>
                      <input
                        type="password"
                        value={stripeSecretInput}
                        onChange={(e) => setStripeSecretInput(e.target.value)}
                        placeholder="sk_test_..."
                        className="w-full bg-[#1f1f1f] text-white px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                      />
                      {formData.stripeSecretKeyHint && (
                        <p className="text-xs text-green-400 mt-2">
                          Saved: {formData.stripeSecretKeyHint} {formData.stripeKeyMode ? `(${formData.stripeKeyMode})` : ''}
                        </p>
                      )}
                    </div>
                    <div className="flex flex-col sm:flex-row sm:items-center sm:gap-3 gap-2">
                      <button
                        type="button"
                        onClick={handleSaveStripeKey}
                        disabled={stripeKeySaving}
                        className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors disabled:opacity-50"
                      >
                        {stripeKeySaving ? 'Saving...' : 'Save Stripe Key'}
                      </button>
                      {stripeKeyMessage && (
                        <span className="text-xs text-green-400">{stripeKeyMessage}</span>
                      )}
                    </div>
                    {error && (
                      <p className="text-xs text-red-400 mt-2">
                        {error}
                      </p>
                    )}
                  </div>
                </div>

                <div className="bg-[#2a2a2a] p-4 rounded-lg space-y-4">
                  <div>
                    <h5 className="font-medium">Payment Methods</h5>
                    <p className="text-sm text-gray-400">Enable at least one payment method for online orders.</p>
                  </div>
                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm font-medium">Pay with QR</p>
                        <p className="text-xs text-gray-400">Show the uploaded static QR and require payment proof upload.</p>
                      </div>
                      <button
                        type="button"
                        onClick={() => toggleOnlinePaymentMethod('payAtCounterEnabled')}
                        className={`w-12 h-6 flex items-center rounded-full p-1 duration-300 ${formData.payAtCounterEnabled ? 'bg-purple-600' : 'bg-gray-600'}`}
                      >
                        <div className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ${formData.payAtCounterEnabled ? 'translate-x-6' : ''}`} />
                      </button>
                    </div>
                    {!formData.duitnowQRUrl && formData.payAtCounterEnabled && (
                      <p className="text-xs text-yellow-400">Upload a DuitNow QR image above so customers can pay with QR.</p>
                    )}
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm font-medium">Pay with Stripe</p>
                        <p className="text-xs text-gray-400">Accept FPX, Apple Pay, Google Pay, and cards.</p>
                      </div>
                      <button
                        type="button"
                        onClick={() => toggleOnlinePaymentMethod('stripePaymentEnabled')}
                        className={`w-12 h-6 flex items-center rounded-full p-1 duration-300 ${formData.stripePaymentEnabled ? 'bg-purple-600' : 'bg-gray-600'}`}
                      >
                        <div className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ${formData.stripePaymentEnabled ? 'translate-x-6' : ''}`} />
                      </button>
                    </div>
                    {!formData.stripeKeyConfigured && (
                      <p className="text-xs text-yellow-400">Add a Stripe secret key to enable online payments.</p>
                    )}
                    {formData.stripePaymentEnabled && (
                      <p className="text-xs text-gray-400">
                        Stripe payout fees will be deducted during payouts.{" "}
                        <a
                          href="https://stripe.com/pricing"
                          target="_blank"
                          rel="noreferrer"
                          className="text-purple-300 hover:text-purple-200 underline"
                        >
                          View Stripe payout fees
                        </a>
                        .
                      </p>
                    )}
                    {paymentMethodError && (
                      <p className="text-xs text-red-400">{paymentMethodError}</p>
                    )}
                  </div>
                </div>

                {hasUnsavedChanges && unsavedChangesType === 'settings' && (
                  <div className="mt-4 text-red-400 text-sm">
                    You have unsaved changes. Click "Save Settings" to apply them.
                  </div>
                )}

                {/* Opening & Closing Times (per day) */}
                <div className="bg-[#2a2a2a] p-4 rounded-lg">
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <h5 className="font-medium">Opening & Closing Times</h5>
                      <p className="text-sm text-gray-400">Auto-enable online ordering during open hours and disable when closed.</p>
                    </div>
                  </div>
                  <div className="space-y-3">
                    {onlineOrderingDays.map(({ key, label }) => {
                      const schedule = formData.onlineOrderingSchedule?.[key] || {};
                      return (
                        <div key={key} className="flex flex-col md:flex-row md:items-center md:gap-4 bg-[#242424] rounded-lg p-3">
                          <div className="flex items-center justify-between md:w-48">
                            <span className="text-white font-medium">{label}</span>
                            <button
                              type="button"
                              onClick={() =>
                                updateOnlineSchedule(key, 'enabled', !schedule.enabled)
                              }
                              className={`w-12 h-6 flex items-center rounded-full p-1 duration-300 ${schedule.enabled ? 'bg-purple-600' : 'bg-gray-600'}`}
                            >
                              <div className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ${schedule.enabled ? 'translate-x-6' : ''}`} />
                            </button>
                          </div>
                          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-3 flex-1 mt-3 md:mt-0">
                            <div>
                              <label className="text-xs text-gray-400 block mb-1">Opening</label>
                              <input
                                type="time"
                                value={schedule.open || ''}
                                onChange={(e) => updateOnlineSchedule(key, 'open', e.target.value)}
                                className="w-full bg-[#1f1f1f] text-white px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                                disabled={!schedule.enabled}
                              />
                            </div>
                            <div>
                              <label className="text-xs text-gray-400 block mb-1">Closing</label>
                              <input
                                type="time"
                                value={schedule.close || ''}
                                onChange={(e) => updateOnlineSchedule(key, 'close', e.target.value)}
                                className="w-full bg-[#1f1f1f] text-white px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                                disabled={!schedule.enabled}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {hasUnsavedChanges && unsavedChangesType === 'schedule' && (
                  <div className="mt-4 text-red-400 text-sm">
                    You have unsaved changes. Click "Save Settings" to apply them.
                  </div>
                )}

              </div>
              
              <div className="mt-8">
                <button
                  onClick={() => {
                    if (formData.enablePickup === false && !formData.enableDelivery) {
                      setPaymentMethodError('Enable at least one fulfillment method: pickup or delivery.');
                      return;
                    }
                    if (!formData.payAtCounterEnabled && !formData.stripePaymentEnabled) {
                      setPaymentMethodError('At least one payment method must be enabled.');
                      return;
                    }
                    if (formData.stripePaymentEnabled && !formData.stripeKeyConfigured) {
                      setPaymentMethodError('Add a Stripe secret key before enabling online payments.');
                      return;
                    }
                    setPaymentMethodError('');
                    setOnlineOrderingSaving(true);
                    handleSave().finally(() => {
                      setOnlineOrderingSaving(false);
                    });
                    setHasUnsavedChanges(false);
                    setUnsavedChangesType('');
                  }}
                  disabled={onlineOrderingSaving}
                  className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-2 rounded-lg font-medium transition-colors disabled:opacity-50"
                >
                  {onlineOrderingSaving ? (
                    <span className="flex items-center gap-2">
                      <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Saving...
                    </span>
                  ) : (
                    'Save Settings'
                  )}
                </button>
                {onlineOrderingMessage && (
                  <span className="ml-4 text-green-400 font-medium animate-fade-in">
                    {onlineOrderingMessage}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {activeTab === 'general' && message && (
        <p className="mt-4 text-green-400 font-semibold">{message}</p>
      )}

      {showPreview && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
          <div className="bg-white text-black w-[300px] p-6 rounded-lg shadow-lg text-sm max-h-[90vh] overflow-y-auto">
            {companyInfo.logoUrl && (
              <img src={companyInfo.logoUrl} alt="Logo" className="h-16 mx-auto mb-4 object-contain" />
            )}
            <h3 className="text-center text-xl font-bold mb-1">{companyInfo.companyName || 'Company Name'}</h3>
            {companyInfo.regNumber && (companyInfo.regType || '').toUpperCase() === 'BRN' && (
              <p className="text-center text-xs mb-1">Reg. Num: {companyInfo.regNumber}</p>
            )}
            {companyInfo.sstNumber && (
              <p className="text-center text-xs mb-1">SST Num: {companyInfo.sstNumber}</p>
            )}
            <p className="text-center text-xs mb-2">{fullAddress}</p>
            <hr className="my-2 border-dashed border-gray-400" />
            <p className="text-xs">Date: {formatDate(new Date().toLocaleString())} {formatTime(new Date().toLocaleString())}<br />Receipt No: 1<br />Mode: Retail</p>
            <hr className="my-2 border-dashed border-gray-400" />

            {/* Item list */}
            <div className="flex justify-between font-bold text-xs mb-1">
              <span>Item</span>
              <span className="text-right min-w-[70px]">Price</span>
            </div>
            <div className="text-xs space-y-1">
              <div className="flex justify-between"><span>Item A x1</span><span className="text-right min-w-[70px]">RM10.00</span></div>
              <div className="flex justify-between"><span>Item B x2</span><span className="text-right min-w-[70px]">RM20.00</span></div>
            </div>

            <hr className="my-2 border-dashed border-gray-400" />
            <div className="text-xs space-y-1">
              <div className="flex justify-between"><span>Subtotal</span><span className="text-right min-w-[70px]">RM30.00</span></div>
              {formData.sst6Enabled && (
              <div className="flex justify-between"><span>SST (6%)</span><span>RM 1.80</span></div>
            )}
            {formData.sst8Enabled && (
              <div className="flex justify-between"><span>SST (8%)</span><span>RM 2.40</span></div>
            )}
            {formData.serviceTax10Enabled && (
              <div className="flex justify-between"><span>Service Tax</span><span>RM 3.00</span></div>
            )}
              <div className="flex justify-between"><span>Discount</span><span className="text-right min-w-[70px]">-RM5.00</span></div>
              <div className="flex justify-between"><span>Rounding</span><span className="text-right min-w-[70px]">+0.00</span></div>
              <div className="flex justify-between font-bold"><span>Total</span><span className="text-right min-w-[70px]">RM30.40</span></div>
              <div className="flex justify-between"><span>Cash</span><span className="text-right min-w-[70px]">RM30.40</span></div>
              <div className="flex justify-between"><span>Change</span><span className="text-right min-w-[70px]">RM0.00</span></div>
            </div>

            <hr className="my-2 border-dashed border-gray-400" />
            <p className="text-center text-xs mb-2">{formData.thankYouNote || 'Thank you and come again!'}</p>
            {formData.receiptFooter && (
              <div className="text-center text-xs text-gray-600 mt-2">{formData.receiptFooter}</div>
            )}
            <p className="text-center text-xs mt-2">Powered by CashMate</p>

            <div className="flex justify-end mt-4">
              <button onClick={() => setShowPreview(false)} className="text-white bg-purple-600 px-4 py-2 rounded hover:bg-purple-700">Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Product Selection Modal */}
      {showProductModal && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
          <div className="bg-[#1f1f1f] rounded-lg p-6 max-w-4xl w-full max-h-[80vh] flex flex-col">
            <h2 className="text-2xl font-semibold mb-2 text-white">Manage Online Ordering Items</h2>
            <p className="text-sm text-gray-400 mb-4">Select which items should be available for online ordering</p>
            
            {/* Search Bar */}
            <div className="mb-4">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search products, bundles, or types..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full bg-[#2a2a2a] text-white px-4 py-2 pl-10 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                />
                <svg className="absolute left-3 top-2.5 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
            </div>

            <div className="space-y-4 overflow-y-auto flex-1">
              {/* Bundles Section */}
              {(() => {
                const filteredBundles = bundles.filter(b => 
                  b.name.toLowerCase().includes(searchQuery.toLowerCase())
                );
                if (filteredBundles.length === 0 && searchQuery) return null;
                
                const allSelected = filteredBundles.every(b => selectedProducts[b.id]);
                
                return filteredBundles.length > 0 && (
                  <div className="bg-[#2a2a2a] p-4 rounded-lg">
                    <div className="flex items-center justify-between mb-3">
                      <div className="flex items-center space-x-3">
                        <h3 className="text-lg font-semibold text-purple-400">Bundles</h3>
                        <span className="text-sm text-gray-400">({filteredBundles.length} items)</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <input
                          type="checkbox"
                          checked={allSelected}
                          onChange={() => {
                            const newSelected = { ...selectedProducts };
                            filteredBundles.forEach(b => {
                              newSelected[b.id] = !allSelected;
                            });
                            setSelectedProducts(newSelected);
                          }}
                          className="form-checkbox h-5 w-5 text-purple-600 rounded"
                        />
                        <span className="text-sm text-gray-400">Select All</span>
                      </div>
                    </div>
                    <div className="space-y-2">
                      {filteredBundles.map(bundle => (
                        <label key={bundle.id} className="flex items-center space-x-3 p-2 hover:bg-[#333] rounded cursor-pointer">
                          <input
                            type="checkbox"
                            checked={selectedProducts[bundle.id] || false}
                            onChange={() => handleProductToggle(bundle.id)}
                            className="form-checkbox h-5 w-5 text-purple-600 rounded"
                          />
                          <span className="text-white">{bundle.name}</span>
                          <span className="text-xs text-gray-400">({bundle.price ? `RM ${bundle.price}` : 'N/A'})</span>
                        </label>
                      ))}
                    </div>
                  </div>
                );
              })()}

              {/* Products by Type */}
              {productTypes.sort((a, b) => a.name.localeCompare(b.name)).map(type => {
                // Get all products of this type first
                const allProductsOfType = products.filter(p => p.type === type.name);
                
                // Filter by search query
                const productsOfType = allProductsOfType.filter(p => 
                  p.name.toLowerCase().includes(searchQuery.toLowerCase())
                );
                
                // Check if type name matches search
                const typeMatchesSearch = type.name.toLowerCase().includes(searchQuery.toLowerCase());
                
                // If type matches search, show all products of that type
                const displayProducts = typeMatchesSearch ? allProductsOfType : productsOfType;
                
                // Show type if: no search, type matches search, or has matching products
                if (displayProducts.length === 0) return null;

                const allSelected = displayProducts.every(p => selectedProducts[p.id]);
                const isExpanded = expandedTypes[type.name] || searchQuery; // Auto-expand when searching

                return (
                  <div key={type.id} className="bg-[#2a2a2a] p-4 rounded-lg">
                    <div className="flex items-center justify-between mb-3">
                      <div className="flex items-center space-x-3">
                        <button
                          onClick={() => toggleTypeExpansion(type.name)}
                          className="text-white hover:text-gray-300"
                        >
                          <svg className={`w-5 h-5 transform transition-transform ${isExpanded ? 'rotate-90' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                        </button>
                        <h3 className="text-lg font-semibold text-white">{type.name}</h3>
                        <span className="text-sm text-gray-400">({displayProducts.length} items)</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <input
                          type="checkbox"
                          checked={allSelected && displayProducts.length > 0}
                          onChange={() => handleTypeToggle(type.name)}
                          className="form-checkbox h-5 w-5 text-purple-600 rounded"
                          disabled={displayProducts.length === 0}
                        />
                        <span className="text-sm text-gray-400">Select All</span>
                      </div>
                    </div>
                    
                    {isExpanded && displayProducts.length > 0 && (
                      <div className="space-y-2 ml-8">
                        {displayProducts.map(product => (
                          <label key={product.id} className="flex items-center space-x-3 p-2 hover:bg-[#333] rounded cursor-pointer">
                            <input
                              type="checkbox"
                              checked={selectedProducts[product.id] || false}
                              onChange={() => handleProductToggle(product.id)}
                              className="form-checkbox h-5 w-5 text-purple-600 rounded"
                            />
                            <span className="text-white">{product.name}</span>
                            <span className="text-xs text-gray-400">({product.price ? `RM ${product.price}` : 'N/A'})</span>
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            <div className="flex gap-3 mt-6 justify-end">
              <button
                onClick={() => {
                  setShowProductModal(false);
                  setSearchQuery('');
                }}
                className="bg-gray-600 hover:bg-gray-700 text-white px-6 py-2 rounded-lg transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  saveOnlineOrderingProducts();
                  setSearchQuery('');
                }}
                className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-2 rounded-lg transition-colors"
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
